<template>
  <v-container id="campaign-overview">
    <div
      v-for="(campaign, index) in this.$store.state.config.campaigns"
      :key="campaign.id"
    >
      <v-row justify="center">
        <v-col cols="12">
          <MaterialCard
            elevation="0"
            color="primary"
            :id="'id' + index"
            :title="campaign.name"
          >
            <!-- Row to show the campaign image and description -->
            <v-row align="center" class="mx-auto">
              <v-col
                v-if="campaign.front_image"
                xl="4"
                lg="6"
                md="6"
                sm="12"
                xs="12"
                class="pb-md-12"
              >
                <v-card
                  class="justify-start"
                  elevation="0"
                  max-width="400"
                  outlined
                >
                  <v-img
                    height="200"
                    width="400"
                    :src="imgUrl + campaign.front_image"
                  ></v-img>
                </v-card>
              </v-col>
              <v-col xl="8" lg="6" sm="12" xs="12" md="6" class="pb-8"
                ><div class="display-1">
                  {{ campaign.description }}
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <!-- Row to show the promotions in cards -->
            <v-row class="mt-1 mb-1">
              <v-col
                md="6"
                v-for="promotion in campaign.promotions"
                :key="promotion.image"
                :lg="determinePromotionCardWidthForLargeScreens(campaign)"
              >
                <Promotion
                  :obtainedStamps="getStampsCollected(campaign)"
                  :img="promotion.image"
                  :promotionInit="promotion"
                ></Promotion>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="mt-4">
              <v-col class="text-center">
                <div
                  class="display-2"
                  v-html="
                    $t('message.stamps_collected', {
                      stamps_collected: getStampsCollected(campaign)
                    })
                  "
                />
              </v-col>
            </v-row>
          </MaterialCard>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Promotion from "./../home/components/Promotion";
import MaterialCard from "../../../../../components/views/MaterialCard";

export default {
  name: "Campaigns",
  components: { MaterialCard, Promotion },
  mounted() {
    if (!this.$store.getters["config/hasCampaigns"]) {
      this.$router.push({ name: this.$store.state.config.main_page });
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL
    };
  },
  methods: {
    getStampsCollected(campaign) {
      return campaign.user_campaigns[0]
        ? campaign.user_campaigns[0].stamps_collected
        : 0;
    },
    determinePromotionCardWidthForLargeScreens(campaign) {
      if (campaign.promotions.length > 2) {
        return 4;
      }
      return 6;
    }
  }
};
</script>
